import BackgroundMask from '../../atoms/mask/backgroundMask';
import ButtonContainer from '../../atoms/container/notAllowedButtonContainer';
import ChannelDown from '../../elements/images/channelDown';
import ChannelLogo from '../../atoms/images/channelLogo';
import ChannelUp from '../../elements/images/channelUp';
import ConfirmButton from '../../atoms/buttons/confirmButton';
import LogoContainer from '../../atoms/container/notAllowedChannelLogoContainer';
import Text from '../../atoms/text/notAllowedChannelText';
import TextContainer from '../../atoms/container/notAllowedChannelTextContainer';
import TranslationManager from '../../../../shared/assets/locale/translationsManager';
import addPlanRequest from '../../../../shared/api/addPlan/request';
import useKeyboard from '../../../../shared/components/utils/hooks/useKeyboard';
import {
  channelDown,
  channelUp,
} from '../../../../shared/store/thunks/channels.thunk';
import { channelsSelector } from '../../../../shared/store/slices/channels.slice';
import { magicRemoteSelector } from '../../../../shared/store/slices/magicRemote.slice';
import { popRoute } from '../../../../shared/store/thunks/route.thunk';
import { useAppDispatch, useAppSelector } from '../../../../shared/store/hooks';
import { useRef, useState } from 'react';

function NotAllowedChannelModal() {
  const dispatch = useAppDispatch();
  const { enabled } = useAppSelector(magicRemoteSelector);
  const { currentChannel } = useAppSelector(channelsSelector);
  const [accepted, setAccepted] = useState(false);

  const channelCodeRef = useRef(currentChannel?.code);
  channelCodeRef.current = currentChannel?.code;

  useKeyboard({
    canBeFocused: false,
    keyDownHandler: (key) => {
      switch (key) {
        case 'UP':
        case 'CHANNEL_UP':
          dispatch(channelUp());
          break;
        case 'DOWN':
        case 'CHANNEL_DOWN':
          dispatch(channelDown());
          break;
        case 'SELECT':
          setAccepted(true);
          addPlanRequest({ channelCode: channelCodeRef.current });
          break;
        case 'BACK':
          dispatch(popRoute());
      }
    },
  });

  return (
    <BackgroundMask>
      <ChannelUp />
      <LogoContainer>
        <ChannelLogo src={currentChannel?.logo} position='none' />
      </LogoContainer>
      <TextContainer>
        <Text>
          {TranslationManager.get(
            accepted
              ? 'MODAL.CHANNEL_NOT_ALLOWED.THANKS'
              : 'MODAL.CHANNEL_NOT_ALLOWED.MESSAGE_TOP'
          )}
        </Text>
        <Text>
          {TranslationManager.get(
            accepted
              ? 'MODAL.CHANNEL_NOT_ALLOWED.CONFIRM_MESSAGE'
              : 'MODAL.CHANNEL_NOT_ALLOWED.MESSAGE_BOTTOM'
          )}
        </Text>
      </TextContainer>
      {!accepted && (
        <ButtonContainer>
          <ConfirmButton
            focused={!enabled}
            onClick={() => {
              setAccepted(true);
              addPlanRequest({ channelCode: channelCodeRef.current });
            }}
          >
            {TranslationManager.get('MODAL.CHANNEL_NOT_ALLOWED.CONFIRM')}
          </ConfirmButton>
        </ButtonContainer>
      )}
      <ChannelDown />
    </BackgroundMask>
  );
}

export default NotAllowedChannelModal;
